import { theme as antdTheme } from "antd";
import { PropsWithChildren, ReactElement } from "react";
import { ThemeProvider } from "styled-components";

export default function StyledThemeProvider({ children }: PropsWithChildren): ReactElement {
  const { token: themeTokens } = antdTheme.useToken();

  return (
    <ThemeProvider theme={themeTokens}>
      {children}
    </ThemeProvider>
  );
};
